<template>
  <div class="height-percent-100 display-flex">
    <div class="width-250 padding-20 bc-white br-4">
      <div class="display-flex ai-center jc-space-between">
        <b class="title-icon">培训试题库</b>
        <el-button @click="addLibrary" class="padding-0" type="text" icon="el-icon-plus">新增试题集</el-button>
      </div>
      <el-input
        class="mt-20 mb-10"
        v-model="searchFormLibrary.fuzzy"
        placeholder="输入关键字搜索"
        clearable
        @input="searchLibrary">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <div class="scrollbar-y">
        <el-scrollbar style="height: calc(100vh - 280px)" v-if="listLibrary.length" ref="scrollbarLibrary">
          <div v-infinite-scroll="getListLibrary" :infinite-scroll-disabled="scrollbarLibraryDisabled">
            <div
              @click="selected = item"
              @contextmenu="rightKey = item"
              v-contextmenu:contextmenu
              class="item"
              :class="{active: item.id === selected.id}"
              v-for="(item,index) in listLibrary"
              :key="index">
              <img src="@/assets/images/wenjianjia.png" alt="">
              <b class="ml-10">{{item.name}}</b>
            </div>
          </div>
          <p class="ta-center fs-14 color-info" v-if="scrollbarLibraryLoading">加载中...</p>
          <p class="ta-center fs-14 color-info" v-if="scrollbarLibraryNoMore">没有更多了</p>
          <p class="ta-center fs-14 color-info" v-else>下拉加载更多</p>
        </el-scrollbar>
        <el-empty v-else :image-size="100"  description="暂无数据"></el-empty>
      </div>
    </div>
    <div class="width-0 flex-1 ml-28 " v-if="selected">
      <div class="display-flex ai-center jc-space-between mb-10">
        <p>{{selected.name}}</p>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="$router.push(`exam-design?libraryTitle=${selected.name}&libraryId=${selected.id}`)">添加题目</el-button>
      </div>
      <div class="scrollbar-y">
        <el-scrollbar style="height: calc(100vh - 204px)" v-if="list.length" ref="scrollbar">
          <div v-infinite-scroll="getList" :infinite-scroll-disabled="scrollbarDisabled">
            <div
              class="bc-white padding-20 br-4 mb-20 fs-14"
              v-for="(item,index) in list"
              :key="index">
              <p class="mt-0 mb-20">{{index+1}}. {{item.title}}</p>
              <div class="display-flex fd-column">
                <div class="mb-10 ml-16 display-flex jc-space-between" v-for="_item in item.options" :key="_item.value">
                  <span :class="item.answer.includes(_item.value) ? 'color-success' : ''">{{_item.label}}</span>
                  <span class="color-success fs-14" v-if="item.answer.includes(_item.value)">( 正确答案 )</span>
                </div>
              </div>
              <p v-if="!item.options.length" class="mb-0 ml-16">请填写内容</p>
              <div class="display-flex fd-row-reverse">
                <div>
                  <el-button class="pb-0 mr-12" type="text" icon="el-icon-edit-outline" @click="edit(item)">编辑</el-button>
                  <el-button class="pb-0 color-danger" type="text" icon="el-icon-delete" @click="del(item)">删除</el-button>
                </div>
              </div>
            </div>
          </div>
          <p class="ta-center fs-14 color-info" v-if="scrollbarLoading">加载中...</p>
          <p class="ta-center fs-14 color-info" v-if="scrollbarNoMore">没有更多了</p>
          <p class="ta-center fs-14 color-info" v-else>下拉加载更多</p>
        </el-scrollbar>
        <el-empty v-else :image-size="100" style="margin-top: 200px;" description="暂无数据"></el-empty>
      </div>
    </div>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="editLibrary">编辑</v-contextmenu-item>
      <v-contextmenu-item @click="delLibrary">删除</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'Index',
  components: { },
  props: {},
  data () {
    return {
      rightKey: null,
      selected: null,
      searchFormLibrary: {
        fuzzy: '',
        pageNum: 1,
        pageSize: 10
      },
      listLibrary: [],
      totalLibrary: 0,
      scrollbarLibraryLoading: false,
      searchForm: {
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      scrollbarLoading: false
    }
  },
  filters: {},
  computed: {
    scrollbarLibraryNoMore () {
      return this.totalLibrary <= this.searchFormLibrary.pageNum * this.searchFormLibrary.pageSize
    },
    scrollbarLibraryDisabled () {
      return this.scrollbarLibraryLoading || this.scrollbarLibraryNoMore
    },
    scrollbarNoMore () {
      return this.total <= this.searchForm.pageNum * this.searchForm.pageSize
    },
    scrollbarDisabled () {
      return this.scrollbarLoading || this.scrollbarNoMore
    },
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchFormLibrary))
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.pageNum !== 1 && newVal.pageNum === oldVal.pageNum) {
          this.searchFormLibrary.pageNum = 1;
        } else {
          // this.getListLibrary()
        }
      },
      deep: true
    },
    selected: {
      handler () {
        this.searchForm.pageNum = 1
        this.getList()
      },
      deep: true
    }
  },
  methods: {
    edit (data) {
      this.$router.push({
        path: 'exam-design',
        query: {
          libraryTitle: this.selected.name,
          libraryId: this.selected.id,
          info: JSON.stringify(data)
        }
      })
    },
    del (data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.exam.del({ id: data.id }).then(res => {
          this.$message.success('删除成功')
          this.searchForm.pageNum = 1
          this.getList()
        })
      }).catch(() => {});
    },
    delLibrary () {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.exam.delLibrary({ id: this.rightKey.id }).then(res => {
          this.$message.success('删除成功')
          this.searchLibrary()
        })
      }).catch(() => {});
    },
    addLibrary () {
      this.$prompt('请输入试题集名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入试题集名称'
      }).then(({ value }) => {
        this.$api.exam.saveLibrary({
          name: value,
          sort: 1
        }).then(res => {
          this.$message.success('新增成功')
          this.searchLibrary()
        })
      }).catch(() => {});
    },
    editLibrary () {
      const data = this.rightKey
      this.$prompt('请输入试题集名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputValue: data.name,
        inputErrorMessage: '请输入试题集名称'
      }).then(({ value }) => {
        console.log(value);
        this.$api.exam.updateLibrary({
          id: data.id,
          name: value,
          sort: data.sort
        }).then(res => {
          this.$message.success('编辑成功')
          this.searchLibrary()
        })
      }).catch(() => {});
    },
    searchLibrary () {
      this.searchFormLibrary.pageNum = 1
      this.getListLibrary()
    },
    getListLibrary: _.debounce(function () {
      const data = {
        fuzzy: this.searchFormLibrary.fuzzy,
        pageNum: this.searchFormLibrary.pageNum,
        pageSize: this.searchFormLibrary.pageSize
      }
      this.scrollbarLibraryLoading = true
      this.$api.exam.listLibrary(data).then(res => {
        if (this.searchFormLibrary.pageNum === 1) {
          this.listLibrary = res.list || []
        } else {
          this.listLibrary.push(...res.list)
        }
        if (this.listLibrary.length) {
          this.selected = this.listLibrary[0]
        }
        this.searchFormLibrary.pageNum++
        this.totalLibrary = res.total
        this.scrollbarLibraryLoading = false
        this.$nextTick(() => {
          this.$refs.scrollbarLibrary.update()
        })
      }).catch(() => {
        this.scrollbarLibraryLoading = false
      })
    }, 500),
    getList: _.debounce(function () {
      const data = {
        questionSetId: this.selected.id,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      }
      this.scrollbarLoading = true
      this.$api.exam.list(data).then(res => {
        if (this.searchForm.pageNum === 1) {
          this.list = res.list || []
        } else {
          this.list.push(...res.list)
        }
        this.searchForm.pageNum++
        this.total = res.total
        this.scrollbarLoading = false
        this.$nextTick(() => {
          this.$refs.scrollbar.update()
        })
      }).catch(() => {
        this.scrollbarLoading = false
      })
    }, 500)
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.getListLibrary()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.title-icon {
  display: block;
  position: relative;
  padding-left: 14px;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 1px;
    width: 4px;
    height: 16px;
    background: #2A5EFF;
    border-radius: 2px;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  cursor: pointer;
}
.active {
  background: #F0F4FF;
  border: 1px solid #1774FF;
}
</style>
